var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('feather-icon',{attrs:{"icon":"EditIcon","svgClasses":"h-5 w-5 mr-4 hover:text-primary cursor-pointer"},on:{"click":_vm.editRecord}}),_c('feather-icon',{attrs:{"icon":"TrashIcon","svgClasses":"h-5 w-5 hover:text-danger cursor-pointer"},on:{"click":_vm.confirmDeleteRecord}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }